import styles from './OperationalPage.module.css';
import { FloraAICard } from '@/features/operational/components/Cards/FloraAICard';
import { InfoCard } from '@/features/operational/components/Cards/InfoCard';
import { InstallmentCard } from '@/features/operational/components/Cards/InstallmentCard';
import { RevenueCard } from '@/features/operational/components/Cards/RevenueCard';
import { MapWidget } from '@/features/operational/components/Widgets/MapWidget';
import { useGetBilling } from '@practium/features/api';
import { useNavigate } from 'react-router-dom';

export const OperationalPage = () => {
	const navigate = useNavigate();
	const { data: billingDocs } = useGetBilling();

	const handleConfigClick = () => navigate('/configuracoes');
	const handlePoliciesClick = () => navigate('/politicas');
	const handleParametersClick = () => navigate('/parametros');
	const handleInstallmentClick = () => navigate('/parcelamento');

	return (
		<div className={styles.page}>
			<div className={styles.layout}>
				<MapWidget />

				<div className={styles.cardsSection}>
					<div className={styles.topSection}>
						<div className={styles.leftColumn}>
							<div className={styles.revenueWrapper}>
								<RevenueCard
									mainValue={billingDocs?.revenueSummary?.mainValue ?? '0'}
									trendValue={billingDocs?.revenueSummary?.trendValue ?? '0'}
									trendDirection={billingDocs?.revenueSummary?.trendDirection ?? 'up'}
									chartData={billingDocs?.revenueByDay ?? []}
								/>
							</div>
							<div className={styles.installmentWrapper}>
								<InstallmentCard onViewMore={handleInstallmentClick} />
							</div>
						</div>

						<div className={styles.rightColumn}>
							<InfoCard
								title="Configurações"
								subtitle="Configure temas e seções importantes da aplicação"
								buttonText="Configurar"
								onButtonClick={handleConfigClick}
								decorativeStyle="grid"
							/>
							<InfoCard
								title="Políticas e Termos"
								subtitle="Gerencie as políticas de privacidade e termos de uso do sistema"
								buttonText="Gerenciar"
								onButtonClick={handlePoliciesClick}
								decorativeStyle="paper"
							/>
							<div className={styles.floraWrapper}>
								<FloraAICard />
							</div>
							<div className={styles.parametersMobileWrapper}>
								<InfoCard
									title="Parâmetros"
									subtitle="Crie regiões customizadas no sistema"
									buttonText="Ver parâmetros"
									onButtonClick={handleParametersClick}
								/>
								<div className={styles.floraSmallItem}>
									<FloraAICard />
								</div>
							</div>
						</div>
					</div>

					<div className={styles.bottomSection}>
						<InfoCard
							title="Parâmetros"
							subtitle="Crie regiões customizadas no sistema e configure individualmente todos os parâmetros associados"
							buttonText="Ver parâmetros"
							onButtonClick={handleParametersClick}
							imageUrl="/images/parametros_card_image.png"
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
